module.exports = __webpack_public_path__ + "static/media/info-4.c2d0e4a5.jpg";